<template lang="pug">
div
  div(v-if="loading")
    v-skeleton-loader.mb-2(type="list-item-two-line")
    v-skeleton-loader(type="list-item-three-line@3")
  div(v-else)
    v-card.rounded-lg(flat)
      .pa-6
        .text-lg.font-semibold.mb-2 {{ title }}
        .text-sm {{ description }}
      v-divider.basic300.mb-2
      apexchart.mb-n4(type="heatmap" width="100%" height="360" :options="chartOptions" :series="series")
      .d-flex.px-4.pb-4
        .flex-grow-1
        v-card.rounded-lg.pa-4.border-neutral300(outlined)
          .d-flex.align-center
            .text-sm.mr-4 High Occupancy
            template(v-for="range in chartOptions.plotOptions.heatmap.colorScale.ranges.slice(1).reverse()")
              v-card.rounded-0.mx-1(:color="range.color" width="40" height="30" flat)
            .text-sm.ml-4 Low Occupancy
</template>

<script>

export default {
  name: 'HeatMapCard',
  props: {
    data: {
      type: Object
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
  }),
  computed: {
    chartOptions () {
      return {
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false
          },
        },
        xaxis: {
          type: 'category',
          position: 'top',
          axisTicks: {
            show: false
          },
          categories: ['12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm']
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        plotOptions: {
          heatmap: {
            radius: 0,
            colorScale: {
              ranges: [
                { from: 0, to: 0, color: '#DFDFDF' },
                { from: 0.1, to: 1, color: '#CFF9F3' },
                { from: 1.1, to: 2, color: '#A8E4DC' },
                { from: 2.1, to: 3, color: '#80CFC5' },
                { from: 3.1, to: 4, color: '#53BBAF' },
                { from: 4.1, to: 5, color: '#00A699' },
                { from: 5.1, to: 6, color: '#058076' },
              ]
            }
          }
        }
      }
    },
    series () {
      return [
        {  name: 'Sun', data: this.data['Sun'] },
        {  name: 'Sat', data: this.data['Sat'] },
        {  name: 'Fri', data: this.data['Fri'] },
        {  name: 'Thu', data: this.data['Thu'] },
        {  name: 'Wed', data: this.data['Wed'] },
        {  name: 'Tue', data: this.data['Tue'] },
        {  name: 'Mon', data: this.data['Mon'] },
      ]
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>